export const Other = 'Something else';
export const NotSure = 'I’m not sure yet';

export enum OnboardingFlows {
    Class = 'onboard_new_class',
    UseCases = 'onboard_new_usecases',
    TargetAudience = 'onboard_new_audience',
    CompanySize = 'onboard_new_company_size',
    Industry = 'onboard_new_company_role',
    Marketing = 'onboard_new_marketing_usecases',
    Seniority = 'onboard_new_seniority',
    NewDepartment = 'onboard_new_department',
    NewWebsite = 'onboard_new_website',
    NewChannel = 'onboard_new_channel',
}

export enum OnboardingClass {
    Personal = 'personal_project',
    Work = 'job',
}
